<template>
  <div class="modal-content-virtual-member">
    <div class="modal-header">
      <h2>Izmeni stanara</h2>
    </div>
    <div class="body">
      <form action="post">
        <div id="first-section">
          <label class="col-form-label col-form-label-lg">
            Ime i prezime
            <span class="mandatory">*</span>
          </label>
          <input
            class="form-control"
            rows="4"
            placeholder="Unesite ime i prezime"
            v-model.trim="virtualMember.full_name"
            @focus="errorOccurred = false"
          />
          <label class="col-form-label col-form-label-lg">
            Opis posebnog dela
            <span class="mandatory">*</span>
          </label>
          <input
            class="form-control"
            rows="4"
            placeholder="Unesite broj stana"
            v-model.trim="virtualMember.div_description"
            @focus="errorOccurred = false"
          />
          <label class="col-form-label col-form-label-lg">Email</label>
          <input
            class="form-control"
            rows="4"
            placeholder="Unesite email"
            v-model.trim="virtualMember.email"
            @focus="errorOccurred = false"
          />
          <label class="col-form-label col-form-label-lg">
            Broj telefona
          </label>
          <input
            class="form-control"
            rows="4"
            placeholder="Unesite broj telefona"
            v-model.trim="virtualMember.phone_number"
            @focus="errorOccurred = false"
          />
          <label class="col-form-label col-form-label-lg">
            Površina
            <span class="mandatory">*</span>
          </label>
          <input
            class="form-control"
            rows="4"
            placeholder="Unesite površinu"
            v-model.trim="virtualMember.area_size"
            @focus="errorOccurred = false"
          />
        </div>
        <div class="input-wrapper">
          <div class="user--mod relative">
            <label class="col-form-label col-form-label-lg"
              >Poveži sa stanarom</label
            >
            <model-select
              ref="member"
              :options="options"
              v-model="selectedMember"
              placeholder="
            Stanar"
            ></model-select>
          </div>
        </div>
      </form>
    </div>

    <hr />
    <div class="footer">
      <div class="error">
        <transition enter-active-class="animated shake">
          <p class="err-msg" v-if="errorOccurred">{{ errorMessage }}</p>
        </transition>
      </div>

      <div class="buttons" style="text-align:center">
        <button
          type="submit"
          class="btn btn-danger btn--mod"
          @click="closeModal"
        >
          Otkaži
        </button>
        <button
          type="submit"
          class="btn btn-primary btn--mod"
          :disabled="loading"
          @click="editAccount"
        >
          <p v-if="!loading">Izmeni</p>
          <spinner :size="20" line-fg-color="#00796b" v-if="loading" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import { financesInstance } from '@/axios/axios.js';
import { ModelSelect } from 'vue-search-select';
import axios from '@/axios/axios.js';

export default {
  components: {
    ModelSelect
  },
  data() {
    return {
      errorOccurred: false,
      errorMessage: '',
      fullName: '',
      divDescription: '',
      email: '',
      memberId: null,
      selectedMember: null,
      virtualMember: {},
      members: [],
      loading: false,
      first: false
    };
  },
  computed: {
    options() {
      let members = [];
      members.push({
        value: null,
        text: 'Bez izabranog stanara'
      });
      let realMembers = this.members.map(e => {
        return { value: e.id, text: e.user_full_name };
      });
      members.push(...realMembers);
      return members;
    }
  },
  watch: {
    selectedMember: function() {
      this.updateMemberFields();
    }
  },
  async created() {
    Object.assign(this.virtualMember, this.$store.state.modal.virtualMember);
    axios
      .post('member/get-members-by-community', {
        community_id: this.$route.params.id,
        active: 1
      })
      .then(({ data }) => {
        this.members = data;
        for (let member of data) {
          if (member.id == this.$store.state.modal.virtualMember.member_id) {
            this.first = true;
            this.selectedMember = member.id;
            break;
          }
        }
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        console.log('VM', this.virtualMember);
      });
  },
  methods: {
    ...mapMutations('modal', ['closeModal']),
    ...mapMutations('table', ['setTableData']),
    ...mapActions('table', ['getAllMembersForCommunityFinances']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    updateMemberFields() {
      if (this.first) {
        this.first = false;
        return;
      }
      this.members.forEach(e => {
        if (e.id === this.selectedMember) {
          this.virtualMember.full_name = e.user_full_name;
          this.virtualMember.div_description = e.div_desc;
          this.virtualMember.email = e.email;
        }
      });
    },
    editAccount() {
      this.errorOccurred = false;

      if (!this.validateInput()) {
        this.errorOccurred = true;
        return;
      }
      this.loading = true;
      let virtualMember = {
        fullName: this.virtualMember.full_name,
        divDescription: this.virtualMember.div_description,
        email: this.virtualMember.email,
        memberId: this.selectedMember,
        phoneNumber: this.virtualMember.phone_number,
        areaSize: this.virtualMember.area_size
      };

      financesInstance
        .put(`members/${this.virtualMember.id}`, virtualMember)
        .then(async res => {
          await this.getAllMembersForCommunityFinances(this.$route.params.id);
          this.loading = false;
          this.closeModal();
          this.showSuccessModal();
        })
        .catch(error => {
          this.loading = false;
          this.showFailModal();
        });
    },
    validateInput() {
      if (this.virtualMember.full_name == '') {
        this.errorMessage = 'Morate uneti ime i prezime';
        return false;
      }
      if (this.virtualMember.div_description == '') {
        this.errorMessage = 'Morate uneti broj stana';
        return false;
      }
      if (this.virtualMember.area_size == '') {
        this.errorMessage = 'Morate uneti površinu';
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="scss">
.modal-content-virtual-member {
  .input-wrapper {
    display: flex;
    width: 100%;
    position: relative;

    .user--mod {
      width: 100%;
      z-index: 5;
      margin-bottom: 2rem;
      .ui.fluid.search {
        width: 100%;
        line-height: 1.5;
        border-radius: 0.3rem;
        border: 1px solid #ced4da;
        font-size: 1rem;
        color: #495057;
        transition: 0.2s all;
        height: calc(2.25rem + 2px);

        input {
          border: none;
          padding: 0.5rem 1rem;
          font-size: 1rem;
          line-height: 1;
          max-width: 100%;
        }

        input:focus {
          border: none;
          outline: none;
          & {
            border-bottom-right-radius: 0;
            border-bottom-left-radius: 0;
          }
        }
        .text {
          position: absolute;
          top: 7px;
          left: 1rem;
          color: #5f5f5f;
          font-size: 1rem;
        }
        .menu {
          border: 1px solid #ced4da;
          border-radius: 0.3rem;
          border-top-width: 0;
          border-top-right-radius: 0;
          border-top-left-radius: 0;
          z-index: 11;
          background-color: white;
          max-height: 7.5rem;
          overflow-y: auto;
          margin: -5px -1px 0px -1px;
          .item {
            z-index: 15;
          }
          .item:hover {
            background-color: rgba(0, 0, 0, 0.05);
            cursor: pointer;
          }

          .item.selected {
            background-color: rgba(0, 0, 0, 0.178);
          }

          .btn--add {
            width: 100%;
          }
        }
      }
    }

    .amount--mod {
      width: 100%;
      margin-bottom: 2rem;
    }

    .input-span {
      position: absolute;
      font-size: 1.5rem;
      color: rgb(95, 95, 95);
      top: 0.5rem;
      pointer-events: none;
      transition: 0.2s all;
      left: 1rem;
    }

    input[type='number'] {
      -moz-appearance: textfield;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }

    input {
      margin-right: 15px;
    }

    .input--:focus ~ .input-span--name,
    .input--name:not(:placeholder-shown) ~ .input-span--name {
      transform: scale(0.75) translateY(-50px) translateX(-30px);
      // opacity: 0;
    }

    .input--amount:focus ~ .input-span--amount,
    .input--amount:not(:placeholder-shown) ~ .input-span--amount {
      transform: scale(0.75) translateY(-50px) translateX(-30px);
    }

    .relative {
      position: relative;
    }
  }

  .body {
    height: 100%;
    width: 100%;
  }

  input {
    margin-bottom: 9px;
    position: relative;
  }

  .footer {
    display: block;
    width: 100%;
    text-align: center;
  }

  .buttons {
    display: inline-flex;
    float: right;
  }

  .btn--mod {
    margin-left: 15px;
    height: 35px;
    margin-left: 5px;
    min-width: 71px;
    align-self: center;
  }

  .btn-primary:hover {
    background-color: var(--primary-color-lighten);
  }

  .btn-primary:active {
    background-color: var(--primary-color) !important;
    border: none;
  }

  .btn-primary:focus {
    box-shadow: 0 0 0 0.2rem var(--primary-color-lighten) !important;
  }

  .error {
    float: left;
    margin-left: 15px;
  }

  .err-msg {
    text-align: center;
    color: red;
  }

  .col-form-label-lg {
    width: 100%;
    position: relative;
  }

  .mandatory {
    color: red;
  }
}
</style>
